exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-page__inner {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  grid-gap: 30px;\n}\n@media only screen and (max-width: 1200px) {\n.profile-page__inner {\n    grid-template-columns: 1fr;\n}\n}\n.profile-page__content {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-auto-rows: 1fr;\n  grid-gap: 30px;\n}\n@media only screen and (max-width: 750px) {\n.profile-page__content {\n    grid-template-columns: 1fr;\n}\n}\n@media only screen and (max-width: 600px) {\n.profile-page__content {\n    grid-auto-rows: 385px 200px 200px;\n}\n}\n", ""]);

// exports
